import { Icons } from '../stories/atoms';

// Mapping from corporateBrandId to Icons
export const corporateBrandIcons: Record<number, Icons> = {
  0: Icons.HM_LOGO,
  1: Icons.COS,
  2: Icons.MONKI,
  3: Icons.WEEKDAY,
  4: Icons.CHEAPMONDAY,
  5: Icons.OTHERSTORIES,
  6: Icons.ARKET,
  7: Icons.AFOUND,
  9: Icons.PLEAT,
};

export const corporateBrandNames: Record<number, string> = {
  0: 'H&M',
  1: 'COS',
  2: 'Monki',
  3: 'Weekday',
  4: 'Cheap Monday',
  5: '& Other Stories',
  6: 'Arket',
  7: 'Afound',
  9: 'Pleat',
};

export const getBrandId = (brandName: string | null): number => {
  return Number(Object.keys(corporateBrandNames).find((key) => corporateBrandNames[Number(key)] === brandName));
};
